import { PageSearchItem } from "../GlobalSearch.types";
import { GlobalSearchItemTypeChip } from "../GlobalSearchItemTypeChip";
import { SearchItemDescription, SearchItemLabel } from "../SearchItemLabel";

export type PageSearchItemViewProps = {
  item: PageSearchItem;
};

export const PageSearchItemView = ({ item }: PageSearchItemViewProps) => {
  return (
    <div className="flex items-center justify-between w-full gap-2">
      <div className="flex items-center gap-2 flex-2 min-w-0">
        <div className="flex flex-col min-w-0 flex-1">
          <SearchItemLabel>{item.title}</SearchItemLabel>
          <SearchItemDescription>{item.path.join(" / ").toUpperCase()}</SearchItemDescription>
        </div>
      </div>
      <div className="flex items-center shrink-0">
        <GlobalSearchItemTypeChip type="page" />
      </div>
    </div>
  );
};
